import { Box, Typography, useMediaQuery } from "@mui/material";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
} from "react";
import styles from "../Day1DragonTiger/styles.module.css";
// import BollywoodCasinoimg from "../../../images/BollywoodCasino/bollywood casino.png";
import FooterLinks from "../FooterLinks";
import { useLocation } from "react-router-dom";
import GameScreen from "./GameScreen";
import FlipClock from "../../FlipClock/FlipClock";
import useRoundLoader from "../../../api/useRoundLoader";

import useCasinoBetplace from "../../../api/useCasinoBetplace";

const svgDiamond = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="9"
    viewBox="0 0 9 9"
    fill="none"
  >
    <path
      d="M8.5 4.5L4.5 8.5L0.5 4.5L4.5 0.5L8.5 4.5Z"
      fill="url(#paint0_linear_7450_30500)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7450_30500"
        x1="2.168"
        y1="2.49771"
        x2="6.12094"
        y2="7.10948"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FE5B42" />
        <stop offset="1" stop-color="#BA0000" />
      </linearGradient>
    </defs>
  </svg>
);

const svgHeart = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="9"
    viewBox="0 0 9 9"
    fill="none"
  >
    <path
      d="M7.86524 1.22C7.01889 0.26 5.65869 0.26 4.81234 1.22L4.5 1.57429L4.18766 1.22C3.34131 0.26 1.98111 0.26 1.13476 1.22C0.288413 2.18 0.288413 3.72286 1.13476 4.68286L4.5 8.5L7.86524 4.68286C8.71159 3.72286 8.71159 2.16857 7.86524 1.22Z"
      fill="url(#paint0_linear_7450_30499)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7450_30499"
        x1="2.05395"
        y1="0.169371"
        x2="7.5616"
        y2="5.02498"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FE5B42" />
        <stop offset="1" stop-color="#BA0000" />
      </linearGradient>
    </defs>
  </svg>
);

const svgClub = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="9"
    viewBox="0 0 9 9"
    fill="none"
  >
    <path
      d="M6.50835 3.38742C6.40264 3.38742 6.3025 3.39801 6.20793 3.40861C6.39708 3.11722 6.50835 2.77285 6.50835 2.40728C6.50835 1.35298 5.61266 0.5 4.50556 0.5C3.39847 0.5 2.50278 1.35298 2.50278 2.40728C2.50278 2.77815 2.61405 3.11722 2.8032 3.40861C2.70306 3.39271 2.60292 3.38742 2.50278 3.38742C1.39569 3.38742 0.5 4.2404 0.5 5.2947C0.5 6.34901 1.39569 7.20199 2.50278 7.20199C3.1815 7.20199 3.77677 6.87881 4.13839 6.39139C4.16064 7.27086 3.87135 7.9649 3.30946 8.5H5.69054C5.13421 7.9649 4.84492 7.27086 4.86161 6.39139C5.22323 6.87881 5.8185 7.20199 6.49722 7.20199C7.60431 7.20199 8.5 6.34901 8.5 5.2947C8.5 4.2404 7.60988 3.38742 6.50835 3.38742Z"
      fill="url(#paint0_linear_7450_30504)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7450_30504"
        x1="1.83369"
        y1="2.25841"
        x2="6.9166"
        y2="7.59638"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#454545" />
        <stop offset="1" />
      </linearGradient>
    </defs>
  </svg>
);

const svgSpade = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="9"
    viewBox="0 0 9 9"
    fill="none"
  >
    <path
      d="M7.8698 3.7L4.50075 0.5L1.1317 3.7C0.289434 4.5 0.289434 5.80286 1.1317 6.60286C1.96193 7.39143 3.28548 7.40286 4.12775 6.64857C4.09165 7.41429 3.80287 8.02 3.29752 8.5H5.69195C5.18659 8.02 4.89781 7.40286 4.86172 6.64857C5.70398 7.40286 7.03957 7.39143 7.85777 6.60286C8.71206 5.79143 8.71206 4.5 7.8698 3.7Z"
      fill="url(#paint0_linear_7450_30505)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7450_30505"
        x1="2.05409"
        y1="2.82251"
        x2="6.69851"
        y2="7.71109"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#454545" />
        <stop offset="1" />
      </linearGradient>
    </defs>
  </svg>
);

const DiamondSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M16.875 8.5L8.875 16.5L0.875 8.5L8.875 0.5L16.875 8.5Z"
      fill="url(#paint0_linear_7450_30527)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7450_30527"
        x1="4.211"
        y1="4.49543"
        x2="12.1169"
        y2="13.719"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FE5B42" />
        <stop offset="1" stop-color="#BA0000" />
      </linearGradient>
    </defs>
  </svg>
);

const HeartSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M14.8555 1.94C13.1628 0.02 10.4424 0.02 8.74968 1.94L8.125 2.64857L7.50031 1.94C5.80762 0.02 3.08722 0.02 1.39452 1.94C-0.298174 3.86 -0.298174 6.94571 1.39452 8.86571L8.125 16.5L14.8555 8.86571C16.5482 6.94571 16.5482 3.83714 14.8555 1.94Z"
      fill="url(#paint0_linear_7450_30545)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7450_30545"
        x1="3.23291"
        y1="-0.161257"
        x2="14.2482"
        y2="9.54996"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FE5B42" />
        <stop offset="1" stop-color="#BA0000" />
      </linearGradient>
    </defs>
  </svg>
);

const ClubSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M12.6417 6.27483C12.4303 6.27483 12.23 6.29603 12.0409 6.31722C12.4192 5.73444 12.6417 5.0457 12.6417 4.31457C12.6417 2.20596 10.8503 0.5 8.63613 0.5C6.42194 0.5 4.63056 2.20596 4.63056 4.31457C4.63056 5.05629 4.85309 5.73444 5.2314 6.31722C5.03112 6.28543 4.83084 6.27483 4.63056 6.27483C2.41638 6.27483 0.625 7.98079 0.625 10.0894C0.625 12.198 2.41638 13.904 4.63056 13.904C5.988 13.904 7.17855 13.2576 7.90177 12.2828C7.94628 14.0417 7.3677 15.4298 6.24392 16.5H11.0061C9.89343 15.4298 9.31485 14.0417 9.34823 12.2828C10.0715 13.2576 11.262 13.904 12.6194 13.904C14.8336 13.904 16.625 12.198 16.625 10.0894C16.625 7.98079 14.8448 6.27483 12.6417 6.27483Z"
      fill="url(#paint0_linear_7450_30533)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7450_30533"
        x1="3.29237"
        y1="4.01682"
        x2="13.4582"
        y2="14.6928"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#454545" />
        <stop offset="1" />
      </linearGradient>
    </defs>
  </svg>
);

const SpadeSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M15.1146 6.9L8.3765 0.5L1.63839 6.9C-0.0461313 8.5 -0.0461313 11.1057 1.63839 12.7057C3.29885 14.2829 5.94597 14.3057 7.63049 12.7971C7.5583 14.3286 6.98075 15.54 5.97003 16.5H10.7589C9.74818 15.54 9.17063 14.3057 9.09843 12.7971C10.783 14.3057 13.4541 14.2829 15.0905 12.7057C16.7991 11.0829 16.7991 8.5 15.1146 6.9Z"
      fill="url(#paint0_linear_7450_30539)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7450_30539"
        x1="3.48319"
        y1="5.14503"
        x2="12.772"
        y2="14.9222"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#454545" />
        <stop offset="1" />
      </linearGradient>
    </defs>
  </svg>
);

const positions = ["Back", "Lay"];

const positions2 = ["Even", "Odd"];
const positions3 = ["Red", "Black"];
const positions4 = ["Diamond", "Club", "Spade", "Heart"];

const rows2 = [
  {
    name: "Dragon",
    blueValue: "2.1",
    redValue: "1.79",
    betType: "dragon_ven_odd",
  },
  {
    name: "Tiger",
    blueValue: "2.1",
    redValue: "1.79",
    betType: "tiger_ven_odd",
  },
];

const rows3 = [
  {
    name: "Dragon",
    blueValue: "1.95",
    redValue: "1.95",
    betType: "dragon_red_black",
  },
  {
    name: "Tiger",
    blueValue: "1.95",
    redValue: "1.95",
    betType: "tiger_red_black",
  },
];

const icons = {
  Diamond: DiamondSVG,
  Club: ClubSVG,
  Spade: SpadeSVG,
  Heart: HeartSVG,
};

const tableData = [
  {
    label: "Dragon",
    values: {
      Diamond: "3.79",
      Club: "3.79",
      Spade: "3.79",
      Heart: "3.79",
    },
    betType: "dragon_symbol",
  },
  {
    label: "Tiger",
    values: {
      Diamond: "3.79",
      Club: "3.79",
      Spade: "3.79",
      Heart: "3.79",
    },
    betType: "tiger_symbol",
  },
];

const t2Data = [
  { nation: "A_DIAMOND", b1: "0", l1: "0" },
  { nation: "A_CLUB", b1: "1.01", l1: "1.03" },
  { nation: "A_HEART", b1: "1.03", l1: "1.05" },
  { nation: "A_SPADE", b1: "1.05", l1: "1.07" },
  { nation: "2_DIAMOND", b1: "1.08", l1: "1.10" },
  { nation: "2_CLUB", b1: "1.10", l1: "1.12" },
  { nation: "2_HEART", b1: "1.12", l1: "1.14" },
  { nation: "2_SPADE", b1: "1.15", l1: "1.17" },
  { nation: "3_DIAMOND", b1: "1.18", l1: "1.20" },
  { nation: "3_CLUB", b1: "1.20", l1: "1.22" },
  { nation: "3_HEART", b1: "1.23", l1: "1.25" },
  { nation: "3_SPADE", b1: "1.27", l1: "1.29" },
  { nation: "4_DIAMOND", b1: "1.30", l1: "1.33" },
  { nation: "4_CLUB", b1: "1.33", l1: "1.36" },
  { nation: "4_HEART", b1: "1.37", l1: "1.40" },
  { nation: "4_SPADE", b1: "1.41", l1: "1.44" },
  { nation: "5_DIAMOND", b1: "1.45", l1: "1.48" },
  { nation: "5_CLUB", b1: "1.49", l1: "1.52" },
  { nation: "5_HEART", b1: "1.54", l1: "1.57" },
  { nation: "5_SPADE", b1: "1.58", l1: "1.61" },
  { nation: "6_DIAMOND", b1: "1.63", l1: "1.67" },
  { nation: "6_CLUB", b1: "1.68", l1: "1.72" },
  { nation: "6_HEART", b1: "1.74", l1: "1.78" },
  { nation: "6_SPADE", b1: "1.80", l1: "1.84" },
  { nation: "7_DIAMOND", b1: "1.87", l1: "1.91" },
  { nation: "7_CLUB", b1: "1.94", l1: "1.98" },
  { nation: "7_HEART", b1: "1.94", l1: "1.98" },
  { nation: "7_SPADE", b1: "1.87", l1: "1.91" },
  { nation: "8_DIAMOND", b1: "1.80", l1: "1.84" },
  { nation: "8_CLUB", b1: "1.74", l1: "1.78" },
  { nation: "8_HEART", b1: "1.68", l1: "1.72" },
  { nation: "8_SPADE", b1: "1.63", l1: "1.67" },
  { nation: "9_DIAMOND", b1: "1.58", l1: "1.61" },
  { nation: "9_CLUB", b1: "1.54", l1: "1.57" },
  { nation: "9_HEART", b1: "1.49", l1: "1.52" },
  { nation: "9_SPADE", b1: "1.45", l1: "1.48" },
  { nation: "10_DIAMOND", b1: "1.41", l1: "1.44" },
  { nation: "10_CLUB", b1: "1.37", l1: "1.40" },
  { nation: "10_HEART", b1: "1.33", l1: "1.36" },
  { nation: "10_SPADE", b1: "1.30", l1: "1.33" },
  { nation: "J_DIAMOND", b1: "1.27", l1: "1.29" },
  { nation: "J_CLUB", b1: "1.23", l1: "1.25" },
  { nation: "J_HEART", b1: "1.20", l1: "1.22" },
  { nation: "J_SPADE", b1: "1.18", l1: "1.20" },
  { nation: "Q_DIAMOND", b1: "1.15", l1: "1.17" },
  { nation: "Q_CLUB", b1: "1.12", l1: "1.14" },
  { nation: "Q_HEART", b1: "1.10", l1: "1.12" },
  { nation: "Q_SPADE", b1: "1.08", l1: "1.10" },
  { nation: "K_DIAMOND", b1: "1.05", l1: "1.07" },
  { nation: "K_CLUB", b1: "1.03", l1: "1.05" },
  { nation: "K_HEART", b1: "1.01", l1: "1.03" },
  { nation: "K_SPADE", b1: "0", l1: "0" },
];

function Day1DragonTiger({ onBetSelect, locked, socketData, gameId = 13 }) {
  const [betDialogOpen, setBetDialogOpen] = useState(false);
  const [selectedBet, setSelectedBet] = useState(null);
  const dragonCard = socketData?.settlement?.dragonCard;
  const roundId = socketData?.roundId;
  const [displayDragonCard, setDisplayDragonCard] = useState(
    socketData?.settlement?.dragonCard || null,
  );
  const [displayTigerCard, setDisplayTigerCard] = useState(
    socketData?.settlement?.tigerCard || null,
  );
  const [cardRevealed, setCardRevealed] = useState(
    !!socketData?.settlement?.dragonCard,
  );
  // const [isNewRound, setIsNewRound] = useState(
  //     !socketData?.settlement?.dragonCard
  // );
  const hasReceivedRealData = useRef(false);
  const [isNewRound, setIsNewRound] = useState(true);
  const [oddsReady, setOddsReady] = useState(false);
  const previousRoundIdRef = useRef(null);
    const [isSocketFresh, setIsSocketFresh] = useState(false);
  const suitKeyMap = { Diamond: "dd", Club: "cc", Spade: "ss", Heart: "hh" };
  const [animTimer, setAnimTimer] = useState(null);
  const [exposureData, setExposureData] = useState(null);
  const { exposureData: hookExposureData } = useCasinoBetplace(gameId, roundId);
  const timeValue = animTimer !== null ? animTimer : socketData?.remainingTime;
  const isTimeUp =
    timeValue !== null && timeValue !== undefined && Number(timeValue) <= 0;
  const settledData = useMemo(
    () => socketData?.settlement,
    [
      socketData?.settlement?.dragonCard,
      socketData?.settlement?.tigerCard,
      socketData?.settlement?.outcome,
      socketData?.settlement?.winner,
      socketData?.roundId,
    ],
  );
  useEffect(() => {
    console.log("Exposure Data Updated:", hookExposureData);
  }, [exposureData]);
  const getExposureValue = (key) => {
    if (!exposureData || typeof exposureData !== "object") return null;

    const keyMap = {
      dragon: "ifDragonWins",
      tiger: "ifTigerWins",
      pair: "ifPair",

      dragon_even: "ifDragonEven",
      dragon_odd: "ifDragonOdd",
      tiger_even: "ifTigerEven",
      tiger_odd: "ifTigerOdd",

      dragon_red: "ifDragonRed",
      dragon_black: "ifDragonBlack",
      tiger_red: "ifTigerRed",
      tiger_black: "ifTigerBlack",

      dragon_dd: "ifDragonDD",
      dragon_cc: "ifDragonCC",
      dragon_hh: "ifDragonHH",
      dragon_ss: "ifDragonSS",

      tiger_dd: "ifTigerDD",
      tiger_cc: "ifTigerCC",
      tiger_hh: "ifTigerHH",
      tiger_ss: "ifTigerSS",
    };

    const mappedKey = keyMap[key] ?? key;
    const val = exposureData[mappedKey];

    if (val === undefined || val === null) return null;
    const num = Number(val);
    if (num === 0) return null;
    return Number(val);
  };

  const ExposureLabel = ({ value, sx = {} }) => {
    if (value === null || value === undefined) return null;

    const isNegative = value < 0;

    return (
      <Typography
        sx={{
          fontSize: "10px",
          fontWeight: 700,
          color: isNegative ? "#ff3030" : "#307e30",
          textAlign: "center",
          lineHeight: 1,
          mt: "3px",
          mb: "2px",
          width: "100%",
          display: "block",
          ...sx, // 👈 override yahin se aayega
        }}
      >
        {value}
      </Typography>
    );
  };

  useEffect(() => {
    if (hookExposureData === null) {
      setExposureData(null);
      return;
    }
    if (hookExposureData && hookExposureData.gameId === gameId) {
      setExposureData(hookExposureData);
    }
  }, [hookExposureData, gameId]);

  useEffect(() => {
    if (roundId) {
      setExposureData(null);
    }
  }, [roundId]);

  const isNewRoundRef = useRef(false);

  useEffect(() => {
    if (!socketData || !socketData.roundId || socketData.roundId === "NA") {
      return;
    }

    hasReceivedRealData.current = true;

    const currentRoundId = socketData.roundId;
    const hasSettlement = !!socketData?.settlement?.dragonCard;

    const isTrulyNewRound =
      socketData?.phase === "PHASE1" ||
      (currentRoundId &&
        currentRoundId !== previousRoundIdRef.current &&
        !hasSettlement);

   if (isTrulyNewRound) {
  previousRoundIdRef.current = currentRoundId;
  setIsNewRound(true);
  setDisplayDragonCard(null);
  setDisplayTigerCard(null);
  setCardRevealed(false);
  setOddsReady(true);
  // yeh add karo:
  prevDragonOddsRef.current = { b1: "1.98", l1: "0", b1Zero: false, l1Zero: true };
  prevTigerOddsRef.current = { b1: "1.98", l1: "0", b1Zero: false, l1Zero: true };
  return;
}

    previousRoundIdRef.current = currentRoundId;

    let revealTimer;
    if (socketData?.settlement?.dragonCard) {
      setIsNewRound(false);
      setDisplayDragonCard(socketData.settlement.dragonCard);
      revealTimer = setTimeout(() => setCardRevealed(true), 0);
    } else {
      setIsNewRound(false);
    }
    if (socketData?.settlement?.tigerCard) {
      setDisplayTigerCard(socketData.settlement.tigerCard);
    }
    setOddsReady(true);
    return () => revealTimer && clearTimeout(revealTimer);
  }, [
    socketData?.phase,
    socketData?.roundId,
    socketData?.settlement?.dragonCard,
    socketData?.settlement?.tigerCard,
  ]);

  const dragonRank = useMemo(() => {
    if (!displayDragonCard) return null;
    return displayDragonCard.trim().toUpperCase().slice(0, -2);
  }, [displayDragonCard]);

  const dragonSuit = useMemo(() => {
    if (!displayDragonCard) return null;
    return displayDragonCard.trim().toUpperCase().slice(-2);
  }, [displayDragonCard]);

  const lowRanks = ["A", "2", "3", "4", "5", "6"];
  const highRanks = ["8", "9", "10", "J", "Q", "K"];

  const isGameReady = !!(
    socketData &&
    socketData.roundId &&
    socketData.roundId !== "NA"
  );
  const parseCardToNation = (cardStr) => {
    if (!cardStr) return null;
    const suitMap = { DD: "DIAMOND", CC: "CLUB", HH: "HEART", SS: "SPADE" };
    const card = cardStr.trim().toUpperCase();
    // Last 2 chars = suit code, rest = rank
    const suitCode = card.slice(-2);
    const rank = card.slice(0, -2);
    const suitFull = suitMap[suitCode];
    if (!suitFull) return null;
    return `${rank}_${suitFull}`;
  };

  const prevDragonOddsRef = useRef({
    b1: "",
    l1: "",
    b1Zero: true,
    l1Zero: true,
  });
  const prevTigerOddsRef = useRef({
    b1: "",
    l1: "",
    b1Zero: true,
    l1Zero: true,
  });
  const dragonOdds = useMemo(() => {
 if (!isGameReady || !oddsReady || !isSocketFresh) {
  return { b1: "", l1: "", b1Zero: true, l1Zero: true };
}
    let result;
    if (isNewRound) {
      result = { b1: "1.98", l1: "0", b1Zero: false, l1Zero: true };
    } else {
      const nation = parseCardToNation(displayDragonCard);
      const matched = nation
        ? t2Data.find((item) => item.nation === nation)
        : null;
      if (!matched) {
        result = { b1: "", l1: "", b1Zero: true, l1Zero: true };
      } else {
        const cleanVal = (val) =>
          !val || val === "0" ? "0" : String(val).trim();
        result = {
          b1: cleanVal(matched.b1),
          l1: cleanVal(matched.l1),
          b1Zero: matched.b1 === "0" || !matched.b1,
          l1Zero: matched.l1 === "0" || !matched.l1,
        };
      }
    }
    prevDragonOddsRef.current = result;
    return result;
  }, [displayDragonCard, isNewRound, isGameReady, oddsReady]);

  const tigerOdds = useMemo(() => {
if (!isGameReady || !oddsReady || !isSocketFresh) {
  return { b1: "", l1: "", b1Zero: true, l1Zero: true };
}
    let result;
    if (isNewRound) {
      result = { b1: "1.98", l1: "0", b1Zero: false, l1Zero: true };
    } else {
      const cardToUse = displayTigerCard || displayDragonCard;
      const nation = parseCardToNation(cardToUse);
      const matched = nation
        ? t2Data.find((item) => item.nation === nation)
        : null;
      if (!matched) {
        result = { b1: "", l1: "", b1Zero: true, l1Zero: true };
      } else {
        const cleanVal = (val) =>
          !val || val === "0" ? "0" : String(val).trim();
        result = {
          b1: cleanVal(matched.b1),
          l1: cleanVal(matched.l1),
          b1Zero: matched.b1 === "0" || !matched.b1,
          l1Zero: matched.l1 === "0" || !matched.l1,
        };
      }
    }
    prevTigerOddsRef.current = result;
    return result;
  }, [displayTigerCard, displayDragonCard, isNewRound, isGameReady, oddsReady]);

  const isDragonBackLayLocked =
    dragonRank !== null &&
    (lowRanks.includes(dragonRank) ||
      (dragonRank === "7" && (dragonSuit === "DD" || dragonSuit === "CC")));

  const isTigerBackLayLocked =
    dragonRank !== null &&
    (highRanks.includes(dragonRank) ||
      (dragonRank === "7" && (dragonSuit === "HH" || dragonSuit === "SS")));

  const rows = useMemo(
    () => [
      {
        name: "Dragon",
        blueValue: dragonOdds.b1,
        redValue: dragonOdds.l1,
        blueZero: dragonOdds.b1Zero,
        redZero: dragonOdds.l1Zero,
        betType: "dragon",
      },
      {
        name: "Tiger",
        blueValue: tigerOdds.b1,
        redValue: tigerOdds.l1,
        blueZero: tigerOdds.b1Zero,
        redZero: tigerOdds.l1Zero,
        betType: "tiger",
      },
    ],
    [dragonOdds, tigerOdds],
  );

  // const formatBetType = (label, position) => {
  //     if (!label || !position) return '';

  //     const base = label.toUpperCase();

  //     // Suits
  //     const suitsMap = {
  //         Diamond: 'DD',
  //         Club: 'CC',
  //         Spade: 'SS',
  //         Heart: 'HH',
  //     };

  //     // Simple bets
  //     const simpleMap = {
  //         Back: 'BACK',
  //         Lay: 'LAY',
  //         Even: 'EVEN',
  //         Odd: 'ODD',
  //         Red: 'RED',
  //         Black: 'BLACK',
  //     };

  //     if (suitsMap[position]) return `${base}_${suitsMap[position]}`;
  //     if (simpleMap[position]) return `${base}_${simpleMap[position]}`;

  //     // Fallback: just uppercase
  //     return `${base}_${position.toUpperCase()}`;
  // };
  const formatBetType = (label, position) => {
    const base = label.toUpperCase();

    if (position === "Back" || position === "Lay") {
      return base; // DRAGON or TIGER
    }

    // Side bets
    switch (position.toUpperCase()) {
      case "EVEN":
        return base + "_EVEN";
      case "ODD":
        return base + "_ODD";
      case "RED":
        return base + "_RED";
      case "BLACK":
        return base + "_BLACK";
      case "PAIR":
        return "PAIR";
      default:
        // Suits
        const suitMap = { Diamond: "DD", Club: "CC", Spade: "SS", Heart: "HH" };
        if (suitMap[position]) {
          return `${base}_${suitMap[position]}`;
        }
        return base;
    }
  };

  const isLargeScreen = useMediaQuery("(min-width:1024px)");
  const getBetCategory = (position) => {
    if (position === "Back") return "BACK";
    if (position === "Lay") return "LAY";
    return "SIDE";
  };

  const handleNumberBoxClick = (
    value,
    label,
    positionIndex,
    positionsArray,
    buttonType = null,
  ) => {
    if (locked) return;

    const position = positionsArray[positionIndex];
    const betType = getBetCategory(position);
    const selection = formatBetType(label, position);

    const betData = {
      selection,
      betType,
      rate: parseFloat(value),
      odds: parseFloat(value),
      position,
      buttonType,
    };

    setSelectedBet(betData);
    setBetDialogOpen(true);
    onBetSelect?.(betData);
  };
  const getCardBetType = (label, suit) => {
    const suitMap = { Diamond: "DD", Club: "CC", Spade: "SS", Heart: "HH" };
    return `${label.toUpperCase()}_${suitMap[suit] || suit.toUpperCase()}`;
  };
  const handleBetScreenClose = () => {
    setBetDialogOpen(false);
    setSelectedBet(null);
  };
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);




useEffect(() => {
  if (socketData?.roundId && socketData.roundId !== "NA" && socketData?.remainingTime !== undefined) {
    setIsSocketFresh(true);
  }
}, [socketData?.roundId, socketData?.remainingTime]);

useEffect(() => {
  const handleVisibilityChange = () => {
    if (document.visibilityState === "visible") {
      setOddsReady(false);
      setIsSocketFresh(false);
    }
  };
  document.addEventListener("visibilitychange", handleVisibilityChange);
  return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
}, []);
  return (
    <Box className={styles.MatchScreen_container}>
      {/* 1st Box */}
      <Box sx={{ width: "100%" }}>
        <Box sx={{ position: "relative", width: "100%" }}>
          <GameScreen
            bettingClosed={socketData?.bettingClosed === true}
            animationTime={
              typeof socketData?.animationTime === "number"
                ? socketData.animationTime
                : 0
            }
            socketData={socketData}
            settledData={settledData}
            remainingTime={socketData?.remainingTime}
            onAnimStart={() => setAnimTimer(0)}
            onAnimEnd={() => setAnimTimer(null)}
          />
          <Box>
            <Box
              sx={{
                position: "absolute",
                bottom: "8px",
                right: "8px",
                zIndex: 10,
                pointerEvents: "none",
              }}
            >
        <FlipClock
  time={isSocketFresh ? (animTimer !== null ? animTimer : socketData?.remainingTime) : null}
/>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className={styles.mainBox}>
        <Box className={styles.box}>
          {/* First Table Section (Black/Lay) */}
          <Box className={styles.RowContainer}>
            <Box className={styles.HeadBox}>
              <Box className={styles.HeadBoxInner}></Box>
              <Box className={styles.HeadBlueBox}>
                <Typography className={styles.HeadBoxText}>Back</Typography>
              </Box>
              <Box className={styles.HeadRedBox}>
                <Typography className={styles.HeadBoxText}>Lay</Typography>
              </Box>
            </Box>
            {rows.map((row, index) => {
              const bettingClosed = socketData?.bettingClosed === true;
              const isDragonLocked =
                row.name === "Dragon" &&
                (bettingClosed || isDragonBackLayLocked);
              const isTigerLocked =
                row.name === "Tiger" && (bettingClosed || isTigerBackLayLocked);

              const backLocked = !isGameReady
                ? true
                : !cardRevealed
                  ? bettingClosed
                  : isDragonLocked || isTigerLocked || row.blueZero;

              const layLocked = !isGameReady
                ? true
                : !cardRevealed
                  ? true
                  : isDragonLocked || isTigerLocked || row.redZero;

              return (
                <Box key={index} className={styles.RowBox}>
                  <Box
                    className={styles.RowBoxInner}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      gap: "2px",
                    }}
                  >
                    <Typography className={styles.RowBoxText}>
                      {row.name}
                    </Typography>
                    <ExposureLabel
                      value={getExposureValue(
                        row.name === "Dragon" ? "dragon" : "tiger",
                      )}
                      sx={{ textAlign: "left", width: "auto" }}
                    />
                  </Box>

                  {/* Back Button */}
                  <Box
                    className={styles.RowBoxBlue}
                    sx={{
                      position: "relative",
                      justifyContent: "center",
                      "&:hover": {
                        cursor: backLocked ? "not-allowed" : "pointer",
                      },
                    }}
                    onClick={() =>
                      !backLocked &&
                      handleNumberBoxClick(
                        row.blueValue,
                        row.name,
                        0,
                        positions,
                        "BlueButton",
                      )
                    }
                  >
                    <Typography className={styles.RowNoText}>
                      {row.blueValue}
                    </Typography>

                    {backLocked && (
                      <Box className={styles.bettinglocked_icon_container}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                        >
                          <path
                            d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z"
                            fill="white"
                          />
                        </svg>
                      </Box>
                    )}
                  </Box>

                  {/* Lay Button */}
                  <Box
                    className={styles.RowBoxRed}
                    sx={{
                      position: "relative",
                      justifyContent: "center",
                      "&:hover": {
                        cursor: layLocked ? "not-allowed" : "pointer",
                      },
                    }}
                    onClick={() =>
                      !layLocked &&
                      handleNumberBoxClick(
                        row.redValue,
                        row.name,
                        1,
                        positions,
                        "RedButton",
                      )
                    }
                  >
                    <Typography className={styles.RowNoText}>
                      {row.redValue}
                    </Typography>
                    <ExposureLabel
                      value={getExposureValue(`${row.name.toLowerCase()}_red`)}
                    />
                    {layLocked && (
                      <Box className={styles.bettinglocked_icon_container}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                        >
                          <path
                            d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z"
                            fill="white"
                          />
                        </svg>
                      </Box>
                    )}
                  </Box>
                </Box>
              );
            })}
          </Box>

          {/* Blue Button (Pair) */}
          <Box className={styles.ButtonContainer}>
            <Typography className={styles.NoText}>12</Typography>
            <Box
              className={styles.BlueButton}
              sx={{
                position: "relative",
                justifyContent: "center",
                "&:hover": {
                  cursor: locked ? "not-allowed" : "pointer",
                },
              }}
              onClick={() =>
                !locked && handleNumberBoxClick("12", "Pair", 0, ["Pair"])
              }
            >
              <Typography className={styles.BlueButtonText}>Pair</Typography>

              {locked && (
                <Box className={styles.bettinglocked_icon_container}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                  >
                    <path
                      d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z"
                      fill="white"
                    />
                  </svg>
                </Box>
              )}
            </Box>
            <ExposureLabel value={getExposureValue("pair")} />
          </Box>

          {/* Second Table Section (Even/Odd) */}
          <Box className={styles.RowContainer}>
            <Box className={styles.HeadBox}>
              <Box className={styles.HeadBoxInner}></Box>
              <Box className={styles.HeadBlueBox}>
                <Typography className={styles.HeadBoxText}>Even</Typography>
              </Box>
              <Box className={styles.HeadBlueBox}>
                <Typography className={styles.HeadBoxText}>Odd</Typography>
              </Box>
            </Box>

            {rows2.map((row, index) => {
              const bettingClosed = socketData?.bettingClosed === true;

              const isDragonEvenOddLocked = row.name === "Dragon"; // cardRevealed hote hi Dragon hamesha lock
              const isTigerEvenOddLocked =
                row.name === "Tiger" && bettingClosed;

              const finalLocked = !cardRevealed
                ? bettingClosed
                : isDragonEvenOddLocked || isTigerEvenOddLocked;
              return (
                <Box key={index} className={styles.RowBox}>
                  <Box className={styles.RowBoxInner}>
                    <Typography className={styles.RowBoxText}>
                      {row.name}
                    </Typography>
                  </Box>
                  <Box
                    className={styles.RowBoxBlue}
                    sx={{
                      position: "relative",
                      justifyContent: "center",
                      "&:hover": {
                        cursor: finalLocked ? "not-allowed" : "pointer",
                      },
                    }}
                    onClick={() =>
                      !finalLocked &&
                      handleNumberBoxClick(
                        row.blueValue,
                        row.name,
                        0,
                        positions2,
                        "BlueButton",
                      )
                    }
                  >
                    <Typography className={styles.RowNoText}>
                      {row.blueValue}
                    </Typography>
                    <ExposureLabel
                      value={getExposureValue(`${row.name.toLowerCase()}_even`)}
                    />

                    {finalLocked && (
                      <Box className={styles.bettinglocked_icon_container}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                        >
                          <path
                            d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z"
                            fill="white"
                          />
                        </svg>
                      </Box>
                    )}
                  </Box>
                  <Box
                    className={styles.RowBoxBlue}
                    sx={{
                      position: "relative",
                      justifyContent: "center",
                      "&:hover": {
                        cursor: finalLocked ? "not-allowed" : "pointer",
                      },
                    }}
                    onClick={() =>
                      !finalLocked &&
                      handleNumberBoxClick(
                        row.redValue,
                        row.name,
                        1,
                        positions2,
                        "BlueButton",
                      )
                    }
                  >
                    <Typography className={styles.RowNoText}>
                      {row.redValue}
                    </Typography>
                    <ExposureLabel
                      value={getExposureValue(`${row.name.toLowerCase()}_odd`)}
                    />
                    {finalLocked && (
                      <Box className={styles.bettinglocked_icon_container}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                        >
                          <path
                            d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z"
                            fill="white"
                          />
                        </svg>
                      </Box>
                    )}
                  </Box>
                </Box>
              );
            })}
          </Box>

          {/* Third Table Section (Red/Black) */}
          <Box className={styles.RowContainer}>
            <Box className={styles.HeadBox}>
              <Box className={styles.HeadBoxInner}></Box>
              <Box className={styles.HeadBlueBox}>
                <Box className={styles.HeadBoxText_container}>
                  <Typography className={styles.HeadBoxText}>Red</Typography>
                  {svgHeart}
                  {svgDiamond}
                </Box>
              </Box>
              <Box className={styles.HeadBlueBox}>
                <Box className={styles.HeadBoxText_container}>
                  <Typography className={styles.HeadBoxText}>Black</Typography>
                  {svgClub}
                  {svgSpade}
                </Box>
              </Box>
            </Box>

            {rows3.map((row, index) => {
              const bettingClosed = socketData?.bettingClosed === true;

              const isDragonRedBlackLocked = row.name === "Dragon";
              const isTigerRedBlackLocked =
                row.name === "Tiger" && bettingClosed;

              const finalLocked = !cardRevealed
                ? bettingClosed
                : isDragonRedBlackLocked || isTigerRedBlackLocked;
              return (
                <Box key={index} className={styles.RowBox}>
                  <Box className={styles.RowBoxInner}>
                    <Typography className={styles.RowBoxText}>
                      {row.name}
                    </Typography>
                  </Box>
                  <Box
                    className={styles.RowBoxBlue}
                    sx={{
                      position: "relative",
                      justifyContent: "center",
                      "&:hover": {
                        cursor: finalLocked ? "not-allowed" : "pointer",
                      },
                    }}
                    onClick={() =>
                      !finalLocked &&
                      handleNumberBoxClick(
                        row.blueValue,
                        row.name,
                        0,
                        positions3,
                        "BlueButton",
                      )
                    }
                  >
                    <Typography className={styles.RowNoText}>
                      {row.blueValue}
                    </Typography>
                    <ExposureLabel
                      value={getExposureValue(
                        `${row.name.toLowerCase()}_black`,
                      )}
                    />
                    {finalLocked && (
                      <Box className={styles.bettinglocked_icon_container}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                        >
                          <path
                            d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z"
                            fill="white"
                          />
                        </svg>
                      </Box>
                    )}
                  </Box>
                  <Box
                    className={styles.RowBoxBlue}
                    sx={{
                      position: "relative",
                      justifyContent: "center",
                      "&:hover": {
                        cursor: finalLocked ? "not-allowed" : "pointer",
                      },
                    }}
                    onClick={() =>
                      !finalLocked &&
                      handleNumberBoxClick(
                        row.redValue,
                        row.name,
                        1,
                        positions3,
                        "BlueButton",
                      )
                    }
                  >
                    <Typography className={styles.RowNoText}>
                      {row.redValue}
                    </Typography>
                    <ExposureLabel
                      value={getExposureValue(`${row.name.toLowerCase()}_red`)}
                    />
                    {finalLocked && (
                      <Box className={styles.bettinglocked_icon_container}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                        >
                          <path
                            d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z"
                            fill="white"
                          />
                        </svg>
                      </Box>
                    )}
                  </Box>
                </Box>
              );
            })}
          </Box>

          {/* Fourth Table Section (Card Suits) */}
          <Box className={styles.CardsContainer}>
            <Box className={styles.CardsContainerInner}>
              <Box className={styles.VerticalContainer}>
                <Box></Box>
                {tableData.map((row, rowIndex) => (
                  <Box key={rowIndex} className={styles.VerticalInnerBox}>
                    <Typography className={styles.InnerText}>
                      {row.label}
                    </Typography>
                  </Box>
                ))}
              </Box>

              {Object.keys(icons).map((key, colIndex) => {
                return (
                  <Box key={colIndex} className={styles.VerticalContainer}>
                    <Box className={styles.VBlueBoxHead}>{icons[key]}</Box>

                    {tableData.map((row, rowIndex) => {
                      const bettingClosed = socketData?.bettingClosed === true;

                      const isDragonSuitLocked = row.label === "Dragon";
                      const isTigerSuitLocked =
                        row.label === "Tiger" && bettingClosed;

                      const finalLocked = !cardRevealed
                        ? bettingClosed
                        : isDragonSuitLocked || isTigerSuitLocked;
                      return (
                        <Box
                          key={rowIndex}
                          className={styles.VBlueBoxRow}
                          sx={{
                            position: "relative",
                            justifyContent: "center",
                            "&:hover": {
                              cursor: finalLocked ? "not-allowed" : "pointer",
                            },
                          }}
                          onClick={() => {
                            if (!finalLocked) {
                              const betType = getCardBetType(row.label, key);
                              handleNumberBoxClick(
                                row.values[key],
                                row.label,
                                colIndex,
                                positions4,
                                null,
                                betType,
                              );
                            }
                          }}
                        >
                          <Typography className={styles.NoText}>
                            {row.values[key]}
                          </Typography>
                          <ExposureLabel
                            value={getExposureValue(
                              `${row.label.toLowerCase()}_${suitKeyMap[key]}`,
                            )}
                          />
                          {finalLocked && (
                            <Box
                              className={styles.bettinglocked_icon_container}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="21"
                                height="20"
                                viewBox="0 0 21 20"
                                fill="none"
                              >
                                <path
                                  d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z"
                                  fill="white"
                                />
                              </svg>
                            </Box>
                          )}
                        </Box>
                      );
                    })}
                  </Box>
                );
              })}
            </Box>
          </Box>
        </Box>

        <FooterLinks
          socketData={socketData}
          settledData={settledData}
          gameType="One_Day_Dragon_Tiger"
        />
      </Box>
    </Box>
  );
}

export default Day1DragonTiger;
